import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

const useDatasetMappedValue = (
  mapValue: number | undefined,
  mapperId: number
): { value: string; isLoading: boolean } => {
  const { data, isLoading } = useGetDatasetMapperData(mapperId);

  if (isLoading) return { value: "", isLoading };
  if (mapValue === undefined) return { value: "-", isLoading };

  const mappedValue = data?.mappings?.[mapValue];
  return { value: String(mappedValue ?? mapValue), isLoading };
};

export default useDatasetMappedValue;
